import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon, ClockIcon, PackageXIcon } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    title: 'Popular Items Go On Allocation',
    description: 'The most sought-after pieces are claimed months before the season begins.',
    icon: PackageXIcon
  }, {
    title: 'Transactional Suppliers',
    description: 'Vendors who treat you like an order number rather than a long-term partner.',
    icon: AlertCircleIcon
  }, {
    title: 'Last-Minute Scrambling',
    description: "Compromising your vision because you're forced to buy what's left over.",
    icon: ClockIcon
  }];
  return <section className="py-24 bg-tcp-pure-black relative" data-id="element-60">
      <div className="container mx-auto px-6 max-w-7xl" data-id="element-61">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-62">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-63">
            <h2 className="font-display text-4xl md:text-5xl font-bold text-white leading-tight mb-6" data-id="element-64">
              The best wholesale Christmas décor sells out based on pre-season
              orders.
            </h2>
            <p className="text-2xl text-tcp-red font-display italic mb-8" data-id="element-65">
              Are you shopping for what's left?
            </p>
            <div className="w-20 h-px bg-white/20" data-id="element-66" />
          </motion.div>

          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} variants={{
          hidden: {
            opacity: 0
          },
          visible: {
            opacity: 1,
            transition: {
              staggerChildren: 0.15
            }
          }
        }} className="space-y-8" data-id="element-67">
            {problems.map((problem, index) => <motion.div key={index} variants={{
            hidden: {
              opacity: 0,
              x: 30
            },
            visible: {
              opacity: 1,
              x: 0,
              transition: {
                duration: 0.6
              }
            }
          }} className="flex gap-6 items-start" data-id="element-68">
                <div className="flex-shrink-0 mt-1" data-id="element-69">
                  <div className="w-10 h-10 rounded-full border border-tcp-red/30 flex items-center justify-center text-tcp-red bg-tcp-red/5" data-id="element-70">
                    <problem.icon size={20} strokeWidth={2} data-id="element-71" />
                  </div>
                </div>
                <div data-id="element-72">
                  <h4 className="text-xl font-semibold text-white mb-2" data-id="element-73">
                    {problem.title}
                  </h4>
                  <p className="text-gray-400" data-id="element-74">{problem.description}</p>
                </div>
              </motion.div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}